module.exports = __webpack_public_path__ + "r-v3/img/coachmark_arrow_blue_06.bd6c49b8.svg";